import { render, staticRenderFns } from "./ProfessionPriceRangesBox.vue?vue&type=template&id=27333c7a"
import script from "./ProfessionPriceRangesBox.vue?vue&type=script&lang=js"
export * from "./ProfessionPriceRangesBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports